import type { IconProps } from "@highoutput/ui-components";
import { Icon } from "@highoutput/ui-components";

export default function Underline(props: IconProps) {
  return (
    <Icon
      width="322"
      height="23"
      viewBox="0 0 322 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <svg
        width="322"
        height="23"
        viewBox="0 0 322 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 6H240.676L73.3748 17H316"
          stroke="#F9D209"
          stroke-opacity="0.2"
          stroke-width="12"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </Icon>
  );
}
